import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { UrineOutputActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-urine-output-slot-v2',
    templateUrl: './urine-output-slot-v2.component.html',
    styleUrl: './urine-output-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UrineOutputSlotComponentV2 implements SheetSlotComponentBase {

	action!: UrineOutputActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: UrineOutputActionV2 | null) {
		this.action = action as UrineOutputActionV2;
		this.value = this.action.volume?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}
